export default function initCarrosselNovidadesDestaqueBlog() {
    const container = document.querySelector('#carrossel-cards-blog');
    if (!container) return;

    let swiperInstance = null;
    const mediaQuery = window.matchMedia('(max-width: 991px)');

    const init = () => {
        if (mediaQuery.matches && !swiperInstance) {
            swiperInstance = new Swiper(container, {
                slidesPerView: 1.1,
                spaceBetween: 24,
                grabCursor: true,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                watchOverflow: true,
                
                pagination: {
                    el: '#carrossel-cards-dots',
                    clickable: true,
                    bulletClass: 'swiper-pagination-bullet',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                },

                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Slide anterior',
                    nextSlideMessage: 'Próximo slide',
                    paginationBulletMessage: 'Ir para o slide {{index}}',
                },
            });
        } else if (!mediaQuery.matches && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    };

    mediaQuery.addEventListener('change', init);
    init();
}